module.exports = __webpack_public_path__ + "static/img/want_world.0d2bde8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/logo/want_world.png
// module id = o2kZ
// module chunks = 1